import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { adminLogin, adminMe } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = unknown, false = anonymous, object = logged in
    const [bootstrapped, setBootstrapped] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem("apib_admin_token");
        if (!token) { setUser(false); setBootstrapped(true); return; }
        adminMe()
            .then(d => setUser(d.user))
            .catch(() => { localStorage.removeItem("apib_admin_token"); setUser(false); })
            .finally(() => setBootstrapped(true));
    }, []);

    const login = useCallback(async (email, password) => {
        const res = await adminLogin(email, password);
        localStorage.setItem("apib_admin_token", res.token);
        setUser(res.user);
        return res.user;
    }, []);

    const logout = useCallback(() => {
        localStorage.removeItem("apib_admin_token");
        setUser(false);
    }, []);

    return <AuthCtx.Provider value={{ user, bootstrapped, login, logout }}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
    return useContext(AuthCtx);
}

export function RequireAdmin({ children }) {
    const { user, bootstrapped } = useAuth();
    const loc = useLocation();
    if (!bootstrapped) {
        return (
            <div className="min-h-screen bg-void flex items-center justify-center">
                <div className="font-mono text-xs text-signal animate-pulse tracking-[0.3em] uppercase">verifying signal…</div>
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/admin/login" state={{ from: loc }} replace />;
    }
    return children;
}
